const translation = {
  title: 'Keşfet',
  sidebar: {
    discovery: 'Keşif',
    chat: 'Sohbet',
    workspace: 'Çalışma Alanı',
    action: {
      pin: 'Sabitle',
      unpin: 'Sabitlemeyi Kaldır',
      rename: 'Yeniden Adlandır',
      delete: 'Sil',
    },
    delete: {
      title: 'Uygulamayı sil',
      content: 'Bu uygulamayı silmek istediğinizden emin misiniz?',
    },
  },
  apps: {
    title: 'Dify Tarafından Keşfet Uygulamaları',
    description: 'Bu şablon uygulamalarını anında kullanın veya şablonlara dayalı kendi uygulamalarınızı özelleştirin.',
    allCategories: 'Önerilen',
  },
  appCard: {
    addToWorkspace: 'Çalışma Alanına Ekle',
    customize: 'Özelleştir',
  },
  appCustomize: {
    title: '{{name}} uygulamasından uygulama oluştur',
    subTitle: 'Uygulama simgesi ve ismi',
    nameRequired: 'Uygulama ismi gereklidir',
  },
  category: {
    Assistant: 'Asistan',
    Writing: 'Yazma',
    Translate: 'Çeviri',
    Programming: 'Programlama',
    HR: 'İK',
    Agent: 'Aracı',
    Workflow: 'İş Akışı',
    Entertainment: 'Eğlence',
  },
}

export default translation
